import React, { useRef, useState } from "react";
import "../ReturnedGoodsFactor.scss";
import "./FactorKol.scss";
import DynaInput from "../../UI/DynaInput/DynaInput";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { DateObject } from "react-multi-date-picker";
import DataTable from "../../../Assets/Images/calendar-1 1.svg";
import { toast } from "react-toastify";

const FactorKol = ({
  sendData,
  setSendData,
  intialData,
  componentData,
  setComponentData,
}) => {
  const dateCal = useRef(null);
  let [date, setDate] = useState(new DateObject());
  const [errors, setErrors] = useState({});


  const submitHandler = (e) => {
    e.preventDefault();
    if(date === ''){
      toast.error('تاریخ را وارد نمایید');
      return
    }
    if(sendData.clientCode === ''){
      toast.error('کد مشتری را انتخاب کنید ');
      return
    }
    if(sendData.salaryTitle === ''){
      toast.error('فیلد عنوان اجرت خالی است');
      return
    }
    if(sendData.amount === ''){
      toast.error('مبلغ اجرت را وارد نمایید')
      return
    }
    if(sendData.returnStatus === ''){
      toast.error('وضعیت مرجوعی را مشخص کنید')
      return
    }

//     e.preventDefault();
//  debugger
//     // Perform form validation
//     const newErrors = {};
//     if(sendData.date.trim() === ""){
//       newErrors.date = "تاریخ ثبت را انتخاب کنید";
//     }
//     if (sendData.clientCode.trim() === "") {
//       newErrors.clientCode = "کد مشتری را وارد کنید";
//     }
//     if (sendData.salaryTitle.trim() === "") {
//       newErrors.salaryTitle = "عنوان اجرت را وارد کنید";
//     }
//     if (sendData.amount.trim() === "") {
//       newErrors.amount = "مبلغ  را وارد کنید";
//     }
//     if (sendData.returnStatus.trim() === "") {
//       newErrors.returnStatus = "وضعیت مرجوعی را انتخاب کنید";
//     }
//     if (sendData.exitStatus.trim() === "") {
//       newErrors.exitStatus = "وضعیت خروج مواد را انتخاب کنید";
//     }
  
//     if (Object.keys(newErrors).length > 0) {
//       // There are validation errors, update the state
//       setErrors(newErrors);
//       return false;
//     } else {
//       // Form is valid, submit the data
//       // Your submit logic here
//     }
  };

  return (
    <div className="factorWrapper__">
      <form className="counterFactorForm__">
        <div className="Date newDate">
          <label>ثبت تاریخ</label>
          <DatePicker
            ref={dateCal}
            calendar={persian}
            className="Date"
            placeholder="تاریخ ثبت را انتخاب کنید"
            locale={persian_fa}
            value={sendData.date}
            onChange={(e) => setSendData({date: e.target.value })}
            calendarPosition="bottom-right"
            hideOnScroll
          />
          <div className="imageDate">
            <img src={DataTable} alt="" />
          </div>
        </div>
        <DynaInput
          typeMode={"select"}
          label={"کد مشتری"}
          optionPlaceholder={"مشتری را انتخاب کنید"}
          className={`solid-login-type inputClass__`}
          // classNameInput={`${errors.clientCode && "error"}`}
          selectOption={intialData.clientCode}
          value={sendData.clientCode}
          onChange={(e) => setSendData({ clientCode: e.target.value })}
        />
        {/* {errors.clientCode && <div className="error-message">{errors.clientCode}</div>} */}
        <DynaInput
          label={"عنوان اجرت"}
          placeholder={"عنوان را وارد کنید"}
          typeMode={"input"}
          type={"text"}
          className={"solid-login-type inputClass__"}
          value={sendData.salaryTitle}
          onChange={(e) => setSendData({ salaryTitle: e.target.value })}
        />
        <DynaInput
          label={"مبلغ اجرت"}
          placeholder={"مبلغ را وارد کنید"}
          typeMode={"input"}
          type={"text"}
          className={"solid-login-type inputClass__"}
          value={sendData.amount}
          onChange={(e) => setSendData({ amount: e.target.value })}
        />
        <DynaInput
          typeMode={"select"}
          label={"وضعیت مرجوعی"}
          optionPlaceholder={"وضعیت مرجوعی را انتخاب کنید"}
          className={"solid-login-type inputClass__"}
          selectOption={intialData.returnStatus}
          value={sendData.returnStatus}
          onChange={(e) => setSendData({ returnStatus: e.target.value })}
        />
        <DynaInput
          typeMode={"select"}
          label={"وضعیت خروج مواد اولیه"}
          optionPlaceholder={"وضعیت را انتخاب کنید"}
          className={"solid-login-type inputClass__"}
          selectOption={intialData.exitStatus}
          value={sendData.exitStatus}
          onChange={(e) => setSendData({ exitStatus: e.target.value })}
        />
        <DynaInput
          label={"توضیحات"}
          placeholder={"توضیحات خود را وارد کنید"}
          typeMode={"textarea"}
          style={{ height: 70 }}
          className={"solid-login-type inputClass__"}
          value={sendData.description}
          onChange={(e) => setSendData({ description: e.target.value })}
        />
        <ul className="detailsFormList__">
          <li>
            جمع کل فاکتور<span>{componentData.sumTotalInvoice} تومان</span>
          </li>
        </ul>
        <div className="formButtons__">
          <button className="printButton__">ثبت و پرینت</button>
          <button className="submitButton__" onClick={submitHandler}>
            ثبت
          </button>
        </div>
      </form>
    </div>
  );
};

export default FactorKol;
